import { createStyleSheet } from '@shared-ui/theme'
import { rf, rh, rw } from '@shared-ui/theme/scale'

export const useCreateStyles = createStyleSheet((theme) => ({
  container: {
    backgroundColor: theme.COLOR_BG_BASE,
    flex: 1,
  },
  headerBlock: {
    alignItems: 'center',
    rowGap: rh(4),
  },
  headerText: {
    color: theme.COLOR_TEXT_PRIMARY,
    fontSize: rf(18),
    lineHeight: rh(22),
  },
  rate: {
    color: theme.COLOR_TEXT_SECONDARY,
    fontSize: rf(16),
    lineHeight: rh(22),
  },
  amountBlock: {
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center',
    rowGap: rh(16),
  },
  amount: {
    color: theme.COLOR_TEXT_PRIMARY,
    fontSize: rf(48),
    letterSpacing: rw(-1.44),
    lineHeight: rf(52.8),
  },
  converted: {
    color: theme.COLOR_TEXT_PRIMARY,
    fontSize: rf(16),
    lineHeight: rh(20),
  },
  swapButton: { alignItems: 'center', justifyContent: 'center', minHeight: rh(24), minWidth: rw(24) },
  chipsRow: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingBottom: rh(16),
    paddingTop: rh(16),
  },
  numpadWrap: {
    alignItems: 'center',
  },
  ctaWrap: {
    paddingHorizontal: theme.SIZE_CONTAINER_PADDING,
    paddingVertical: rh(16),
  },
}))
